import { render, staticRenderFns } from "./FiltrosSaborDaSerra.vue?vue&type=template&id=26f2bf48&scoped=true&"
import script from "./FiltrosSaborDaSerra.vue?vue&type=script&lang=js&"
export * from "./FiltrosSaborDaSerra.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosSaborDaSerra.vue?vue&type=style&index=0&id=26f2bf48&scoped=true&lang=css&"
import style1 from "./FiltrosSaborDaSerra.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f2bf48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VContainer,VIcon,VNavigationDrawer,VRow,VSelect,VTooltip})
